import React from 'react';
import { track } from '../modules/tracking';
import PropTypes from 'prop-types';

let Link;

const text = 'The Sunset Burger. Back by popular demand!';

const motion =
    typeof window !== 'undefined' &&
    window.matchMedia &&
    (window.matchMedia('(prefers-reduced-motion: no-preference)') || {})
        .matches;

if (motion) {
    Link = require('react-anchor-link-smooth-scroll').default;
}

function TheSunsetBurgerBanner({ section }) {
    const sectionId = (section.id || '').replace(/:/g, '_');

    function afterClick(e) {
        const hash = (e.target.href || '').split('#')[1];
        const section = document.getElementById(hash);
        let name;
        if (section && section.querySelector) {
            name =
                (section.querySelector('h2') || {}).innerText ||
                'burger, pitta, wrap';
        }

        track(`The Sunset Burger: Click: Jump page to: ${name}`)();

        const target = document.getElementById(hash);

        if (target) {
            const anchor = target.querySelector('button');
            if (anchor && anchor.focus) {
                if (motion) {
                    setTimeout(() => {
                        anchor.focus();
                    }, 750);
                } else {
                    anchor.focus();
                }
            }
        }
    }

    return (
        <div className='ssb'>
            {motion ? (
                <Link href={`#${sectionId}`} onClick={afterClick}>
                    <span>{text}</span>
                </Link>
            ) : (
                <a href={`#${sectionId}`} onClick={afterClick}>
                    <span>{text}</span>
                </a>
            )}
        </div>
    );
}

TheSunsetBurgerBanner.propTypes = {
    section: PropTypes.object
};

export { TheSunsetBurgerBanner };
